export function isNativeApp() {
  try {
    return Boolean(typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.());
  } catch {
    return false;
  }
}
